import { render, staticRenderFns } from "./IconEnvelopeMagnifyingGlass.vue?vue&type=template&id=fbd3ef56"
import script from "./IconEnvelopeMagnifyingGlass.vue?vue&type=script&lang=js"
export * from "./IconEnvelopeMagnifyingGlass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports